var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossHair2 = function SvgCrossHair2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.75 4.882A3.15 3.15 0 0 0 4.082 7.55h.868v.9h-.868a3.15 3.15 0 0 0 2.668 2.668v-.868h.9v.868a3.15 3.15 0 0 0 2.668-2.668H9.45v-.9h.868A3.15 3.15 0 0 0 7.65 4.882v.868h-.9zM3.175 7.55A4.05 4.05 0 0 1 6.75 3.975V3.05h.9v.925a4.05 4.05 0 0 1 3.575 3.575h.925v.9h-.925a4.05 4.05 0 0 1-3.575 3.575v.925h-.9v-.925A4.05 4.05 0 0 1 3.175 8.45H2.25v-.9zM8.55 8a1.35 1.35 0 1 1-2.7 0 1.35 1.35 0 0 1 2.7 0"
  })));
};
export default SvgCrossHair2;